module.exports = __webpack_public_path__ + "media/watersplash.53ecf348.webm";